import { rawDatasetMetas } from "@/raw/datasets/registry";
import { cn } from "@/lib/cn";
import { Link, useLocation } from "react-router-dom";

interface DatasetNavProps {
  className?: string;
}

export function DatasetNav({ className }: DatasetNavProps) {
  const location = useLocation();

  return (
    <nav className={cn("space-y-1", className)} aria-label="Datasets">
      {rawDatasetMetas.map((dataset, index) => {
        const active = location.pathname === dataset.route;
        return (
          <Link
            key={dataset.id}
            to={dataset.route}
            className={cn(
              "flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm transition-colors",
              active
                ? "bg-white font-medium text-[var(--color-text)] shadow-sm ring-1 ring-[var(--color-border)]"
                : "text-[var(--color-text-muted)] hover:bg-white/70 hover:text-[var(--color-text)]",
            )}
          >
            <span className="w-5 text-xs tabular-nums opacity-50">
              {String(index + 1).padStart(2, "0")}
            </span>
            <span>{dataset.title}</span>
          </Link>
        );
      })}
    </nav>
  );
}
